/**
 * 品牌包接线层（Wave 4 R3 / T4.7 集成）。
 *
 * 把品牌包数据源（后端 API）与主题应用（applyBrandPack）串起来：
 * - loadBrandPacks：优先调 GET /api/v1/brand-packs，失败/空列表降级为内置包；
 * - applyBrandPackToTheme：品牌包 tokens → Theme 映射（薄封装，供面板接线与测试）。
 */
import type { BrandPack, Theme } from "@shared/types";

import { listBrandPacks } from "@/services/debugpavilion";

import { applyBrandPack, listBuiltinBrandPacks } from "./brand-packs";

/**
 * 加载品牌包列表：优先后端 API（6 内置 + 自定义包），
 * 请求失败或返回空时降级为前端内置 6 包，保证主题面板始终可用。
 */
export async function loadBrandPacks(): Promise<BrandPack[]> {
  try {
    const packs = await listBrandPacks();
    if (packs && packs.length > 0) {
      return packs;
    }
  } catch {
    // 后端不可用：走内置兜底，不向上抛错
  }
  return listBuiltinBrandPacks();
}

/**
 * 将品牌包应用到当前 Theme（§5.5 → §5.4 映射，见 brand-packs.ts applyBrandPack）。
 * 面板"一键应用"后调用方应以返回的 Theme 调用 builder-store 的 updateTheme，
 * 从而保留 undo/redo 能力。
 */
export function applyBrandPackToTheme(pack: BrandPack, theme: Theme = {}): Theme {
  return applyBrandPack(pack, theme);
}
